const a = [{
    "zoom": [
        {
            "conversation_start_date": "2022-05-01",
            "user_initiated_conversations": 5,
            "business_initiated_conversations": 10
        },
        {
            "conversation_start_date": "2022-05-02",
            "user_initiated_conversations": 11,
            "business_initiated_conversations": 8
        },
        {
            "conversation_start_date": "2022-05-03",
            "user_initiated_conversations": 7,
            "business_initiated_conversations": 55
        },
        {
            "conversation_start_date": "2022-05-04",
            "user_initiated_conversations": 12,
            "business_initiated_conversations": 75
        },
        {
            "conversation_start_date": "2022-05-05",
            "user_initiated_conversations": 8,
            "business_initiated_conversations": 2
        },
        {
            "conversation_start_date": "2022-05-06",
            "user_initiated_conversations": 4,
            "business_initiated_conversations": 1
        },
        {
            "conversation_start_date": "2022-05-09",
            "user_initiated_conversations": 5,
            "business_initiated_conversations": 5
        },
        {
            "conversation_start_date": "2022-05-10",
            "user_initiated_conversations": 8,
            "business_initiated_conversations": 4
        },
        {
            "conversation_start_date": "2022-05-11",
            "user_initiated_conversations": 3,
            "business_initiated_conversations": 18
        },
        {
            "conversation_start_date": "2022-05-12",
            "user_initiated_conversations": 5,
            "business_initiated_conversations": 6
        },
        {
            "conversation_start_date": "2022-05-13",
            "user_initiated_conversations": 8,
            "business_initiated_conversations": 7
        },
        {
            "conversation_start_date": "2022-05-16",
            "user_initiated_conversations": 3,
            "business_initiated_conversations": 10
        },
        {
            "conversation_start_date": "2022-05-17",
            "user_initiated_conversations": 3,
            "business_initiated_conversations": 20
        },
        {
            "conversation_start_date": "2022-05-18",
            "user_initiated_conversations": 3,
            "business_initiated_conversations": 30
        },
        {
            "conversation_start_date": "2022-05-19",
            "user_initiated_conversations": 4,
            "business_initiated_conversations": 40
        },
        {
            "conversation_start_date": "2022-05-20",
            "user_initiated_conversations": 2,
            "business_initiated_conversations": 80
        },
        {
            "conversation_start_date": "2022-05-23",
            "user_initiated_conversations": 2,
            "business_initiated_conversations": 100
        },
        {
            "conversation_start_date": "2022-05-24",
            "user_initiated_conversations": 8,
            "business_initiated_conversations": 110
        },
        {
            "conversation_start_date": "2022-05-25",
            "user_initiated_conversations": 5,
            "business_initiated_conversations": 220
        },
        {
            "conversation_start_date": "2022-05-26",
            "user_initiated_conversations": 9,
            "business_initiated_conversations": 330
        },
        {
            "conversation_start_date": "2022-05-27",
            "user_initiated_conversations": 9,
            "business_initiated_conversations": 400
        },
        {
            "conversation_start_date": "2022-05-28",
            "user_initiated_conversations": 5,
            "business_initiated_conversations": 200
        },
        {
            "conversation_start_date": "2022-05-29",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 150
        },
        {
            "conversation_start_date": "2022-05-30",
            "user_initiated_conversations": 12,
            "business_initiated_conversations": 110
        },
        {
            "conversation_start_date": "2022-05-31",
            "user_initiated_conversations": 5,
            "business_initiated_conversations": 80
        },
        {
            "conversation_start_date": "2022-06-01",
            "user_initiated_conversations": 6,
            "business_initiated_conversations": 60
        },
        {
            "conversation_start_date": "2022-06-02",
            "user_initiated_conversations": 7,
            "business_initiated_conversations": 70
        },
        {
            "conversation_start_date": "2022-06-03",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 50
        },
        {
            "conversation_start_date": "2022-06-05",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 40
        },
        {
            "conversation_start_date": "2022-06-06",
            "user_initiated_conversations": 4,
            "business_initiated_conversations": 30
        },
        {
            "conversation_start_date": "2022-06-07",
            "user_initiated_conversations": 8,
            "business_initiated_conversations": 20
        },
        {
            "conversation_start_date": "2022-06-08",
            "user_initiated_conversations": 5,
            "business_initiated_conversations": 10
        },
        {
            "conversation_start_date": "2022-06-09",
            "user_initiated_conversations": 2,
            "business_initiated_conversations": 9
        },
        {
            "conversation_start_date": "2022-06-10",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 8
        },
        {
            "conversation_start_date": "2022-06-11",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 25
        },
        {
            "conversation_start_date": "2022-06-12",
            "user_initiated_conversations": 2,
            "business_initiated_conversations": 45
        },
        {
            "conversation_start_date": "2022-06-14",
            "user_initiated_conversations": 4,
            "business_initiated_conversations": 67
        },
        {
            "conversation_start_date": "2022-06-15",
            "user_initiated_conversations": 7,
            "business_initiated_conversations": 20
        },
        {
            "conversation_start_date": "2022-06-16",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 25
        },
        {
            "conversation_start_date": "2022-06-17",
            "user_initiated_conversations": 8,
            "business_initiated_conversations": 28
        },
        {
            "conversation_start_date": "2022-06-20",
            "user_initiated_conversations": 3,
            "business_initiated_conversations": 30
        },
        {
            "conversation_start_date": "2022-06-21",
            "user_initiated_conversations": 14,
            "business_initiated_conversations": 42
        },
        {
            "conversation_start_date": "2022-06-22",
            "user_initiated_conversations": 13,
            "business_initiated_conversations": 49
        },
        {
            "conversation_start_date": "2022-06-23",
            "user_initiated_conversations": 11,
            "business_initiated_conversations": 50
        },
        {
            "conversation_start_date": "2022-06-24",
            "user_initiated_conversations": 4,
            "business_initiated_conversations": 60
        },
        {
            "conversation_start_date": "2022-06-25",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 750
        },
        {
            "conversation_start_date": "2022-06-27",
            "user_initiated_conversations": 8,
            "business_initiated_conversations": 70
        },
        {
            "conversation_start_date": "2022-06-28",
            "user_initiated_conversations": 7,
            "business_initiated_conversations": 60
        },
        {
            "conversation_start_date": "2022-06-29",
            "user_initiated_conversations": 3,
            "business_initiated_conversations": 5
        },
        {
            "conversation_start_date": "2022-06-30",
            "user_initiated_conversations": 2,
            "business_initiated_conversations": -1
        },
        {
            "conversation_start_date": "2022-07-01",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 2
        },
        {
            "conversation_start_date": "2022-07-04",
            "user_initiated_conversations": 1,
            "business_initiated_conversations": 5
        },
        {
            "conversation_start_date": "2022-07-05",
            "user_initiated_conversations": 2,
            "business_initiated_conversations": 8
        },
        {
            "conversation_start_date": "2022-07-06",
            "user_initiated_conversations": 2,
            "business_initiated_conversations": 10
        },
        {
            "conversation_start_date": "2022-07-07",
            "user_initiated_conversations": 2,
            "business_initiated_conversations": 20
        },
        {
            "conversation_start_date": "2022-07-08",
            "user_initiated_conversations": 4,
            "business_initiated_conversations": 30
        },
        {
            "conversation_start_date": "2022-07-11",
            "user_initiated_conversations": 4,
            "business_initiated_conversations": 40
        },
        {
            "conversation_start_date": "2022-07-12",
            "user_initiated_conversations": 3,
            "business_initiated_conversations": 50
        }
    ],
    "single": [{"conversation_start_date":"2022-07-12","user_initiated_conversations":1,"business_initiated_conversations":0}],
    "mapdata": [
        { "conversation_start_date": "2021-01-01", "user_initiated_conversations": 6, "business_initiated_conversations": 10 },
        { "conversation_start_date": "2021-02-21", "user_initiated_conversations": 7, "business_initiated_conversations": 11 },
        { "conversation_start_date": "2021-03-03", "user_initiated_conversations": 1, "business_initiated_conversations": 130 },
        { "conversation_start_date": "2021-04-05", "user_initiated_conversations": 1, "business_initiated_conversations": 100 },
        { "conversation_start_date": "2021-05-06", "user_initiated_conversations": 4, "business_initiated_conversations": 50 },
        { "conversation_start_date": "2021-06-07", "user_initiated_conversations": 8, "business_initiated_conversations": 80 },
        { "conversation_start_date": "2021-07-08", "user_initiated_conversations": 5, "business_initiated_conversations": 30 },
        { "conversation_start_date": "2021-08-09", "user_initiated_conversations": 2, "business_initiated_conversations": 10 },
        { "conversation_start_date": "2021-09-10", "user_initiated_conversations": 1, "business_initiated_conversations": 15 },
        { "conversation_start_date": "2021-10-11", "user_initiated_conversations": 1, "business_initiated_conversations": 20 },
        { "conversation_start_date": "2021-11-12", "user_initiated_conversations": 2, "business_initiated_conversations": 5 },
        { "conversation_start_date": "2021-12-14", "user_initiated_conversations": 4, "business_initiated_conversations": 3 },
        { "conversation_start_date": "2022-01-15", "user_initiated_conversations": 7, "business_initiated_conversations": 1 },
        { "conversation_start_date": "2022-02-16", "user_initiated_conversations": 1, "business_initiated_conversations": 8 },
        { "conversation_start_date": "2022-03-17", "user_initiated_conversations": 8, "business_initiated_conversations": 51 },
        { "conversation_start_date": "2022-04-20", "user_initiated_conversations": 3, "business_initiated_conversations": 55 },
        { "conversation_start_date": "2022-05-21", "user_initiated_conversations": 14, "business_initiated_conversations": 60 },
        { "conversation_start_date": "2022-06-22", "user_initiated_conversations": 13, "business_initiated_conversations": 70 },
        { "conversation_start_date": "2022-07-23", "user_initiated_conversations": 11, "business_initiated_conversations": 80 },
        { "conversation_start_date": "2022-08-24", "user_initiated_conversations": 4, "business_initiated_conversations": 90 },
        { "conversation_start_date": "2022-09-25", "user_initiated_conversations": 1, "business_initiated_conversations": 750 },
        { "conversation_start_date": "2022-10-27", "user_initiated_conversations": 8, "business_initiated_conversations": 60 },
        { "conversation_start_date": "2022-11-01", "user_initiated_conversations": 7, "business_initiated_conversations": 50 },
        { "conversation_start_date": "2022-12-20", "user_initiated_conversations": 3, "business_initiated_conversations": 10 },
        { "conversation_start_date": "2022-12-21", "user_initiated_conversations": 2, "business_initiated_conversations": 20 },
        { "conversation_start_date": "2022-12-25", "user_initiated_conversations": 1, "business_initiated_conversations": 30 },
        { "conversation_start_date": "2022-12-31", "user_initiated_conversations": 1, "business_initiated_conversations": 40 }]
}]
export class mock {
    zoom = a[0].zoom;
    mapdata = a[0].mapdata;
    single = a[0].single
}